<template>
  <div class="flex justify-center">
    <div class="flex flex-col justify-center items-start pt-[72px] xl:pt-[20vh] pb-[100px]">
      <img src="@/assets/images/logo.svg" alt="logo" class="h-[48px] mb-[50px]" />
      <img src="@/assets/images/error_default.svg" alt="error" class="mb-6" />
      <h3 class="text-[22px] xl:text-[32px] leading-[33px] xl:leading-[48px] text-[#2A333C] font-bold mb-7">{{ title }}</h3>
      <p class="text-[#3F4D5A] text-base mb-11" v-html="text"></p>
      <div v-if="isTimeout" class="flex gap-3">
        <button class="btn px-10 py-4 bg-[#F0F2F5] hover:bg-[#E1E6EA] border-0 text-[#3F4D5A] font-bold" @click="goChannelTalk">문의하기</button>
        <button class="btn px-10 py-4 bg-[#016FF2] hover:bg-[#2A8BFE] border-0 text-white font-bold" @click="goHome">이전으로 돌아가기</button>
      </div>
      <button v-else class="btn px-10 py-4 bg-[#016FF2] hover:bg-[#2A8BFE] border-0 text-white font-bold" @click="goBack">{{ confirmText }}</button>
    </div>
  </div>
</template>

<script>
import { useCommonStore } from '@/store';
export default {
  name: 'ErrorPage',
  props: {
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      commonStore: useCommonStore(),
      title: '',
      text: '',
      confirmText: '',
      isTimeout: false,
      type: '',
    };
  },
  mounted() {
    this.type = this.$route.query?.type;
    switch (this.error.statusCode) {
      case 404:
      case 403:
      case 401:
      case 400: {
        this.title = '요청하신 페이지를 찾을 수 없습니다.';
        this.text = '올바르지 않은 주소를 입력했거나,<br>해당 페이지에 접근 권한이 없습니다.';
        this.confirmText = '홈으로 가기';
        break;
      }
      case 408: {
        this.title = '시간이 초과되어 요청이 만료됐습니다.';
        this.text = '업로드 파일 크기가 크거나,<br>올바르지 않은 주소를 입력했거나,<br>인터넷 연결 상태가 좋지 않을 수 있습니다.<br>현상이 지속될 경우 고객센터로 문의해주세요.';
        this.confirmText = '이전으로 돌아가기';
        this.isTimeout = true;
        break;
      }
      case 500:
      case 503:
      default: {
        this.title = '페이지 로딩 중 오류가 발생했습니다.';
        this.text = '오류 발생 원인을 확인하고 있습니다.<br>잠시 후 다시 시도해주세요.<br>감사합니다.';
        this.confirmText = '홈으로 가기';
      }
    }
  },
  methods: {
    goChannelTalk() {
      location.href = "https://webchat.thecloudgate.io/webChat?brandKey=ikniBzmD4uNwfYmLw07ugQ&channelType=chat";
    },
    async goBack() {
      const session = await this.commonStore.getSessions();
      switch (this.type) {
        case 'auth': {
          this.$router.replace({ path: '/auth' });
          break;
        }
        case 'resetpw': {
          this.$router.replace({ path: '/auth/login' });
          break;
        }
        case 'inactive': {
          this.$router.replace({ path: '/auth/login' });
          break;
        }
        case 'notfound': {
          if (session) {
            this.$router.replace({ path: '/dashboard' });
          } else {
            this.$router.replace({ path: '/' });
          }
          break;
        }
        case 'timeout': {
          this.$router.back();
          break;
        }
        default: {
          if (session) {
            this.$router.replace({ path: '/dashboard' });
          } else {
            this.$router.replace({ path: '/' });
          }
        }
      }
    },
    goHome() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
h1 {
  font-size: 20px;
}
</style>
